const getRandomImage = (random: string) => {
  return `https://i.pravatar.cc/150?u=${random}`;
};
export { getRandomImage };
